module.exports = __webpack_public_path__ + "media/images/app/colors/colors-orange-b5b0365169b3057b424ab7a7d0578ab2.webp";